import { PositionsAllocationModalComponent } from 'pages/Settings/pages/Positions/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModal.component';
import { PositionsAllocationViewUIProvider } from 'pages/Settings/pages/Positions/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModal.ui.context';
import { FC } from 'react';

export const PositionsAllocationModal: FC = () => {
  return (
    <PositionsAllocationViewUIProvider>
      <PositionsAllocationModalComponent />
    </PositionsAllocationViewUIProvider>
  );
};
